module.exports = (__webpack_require__(15))("TSYQ");